/*
 * Copyright (c) 2020-2025 Estonian Information System Authority
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var Action;
(function (Action) {
    Action["WARNING"] = "web-eid:warning";
    Action["STATUS"] = "web-eid:status";
    Action["STATUS_ACK"] = "web-eid:status-ack";
    Action["STATUS_SUCCESS"] = "web-eid:status-success";
    Action["STATUS_FAILURE"] = "web-eid:status-failure";
    Action["AUTHENTICATE"] = "web-eid:authenticate";
    Action["AUTHENTICATE_ACK"] = "web-eid:authenticate-ack";
    Action["AUTHENTICATE_SUCCESS"] = "web-eid:authenticate-success";
    Action["AUTHENTICATE_FAILURE"] = "web-eid:authenticate-failure";
    Action["GET_SIGNING_CERTIFICATE"] = "web-eid:get-signing-certificate";
    Action["GET_SIGNING_CERTIFICATE_ACK"] = "web-eid:get-signing-certificate-ack";
    Action["GET_SIGNING_CERTIFICATE_SUCCESS"] = "web-eid:get-signing-certificate-success";
    Action["GET_SIGNING_CERTIFICATE_FAILURE"] = "web-eid:get-signing-certificate-failure";
    Action["SIGN"] = "web-eid:sign";
    Action["SIGN_ACK"] = "web-eid:sign-ack";
    Action["SIGN_SUCCESS"] = "web-eid:sign-success";
    Action["SIGN_FAILURE"] = "web-eid:sign-failure";
})(Action || (Action = {}));
export default Action;
//# sourceMappingURL=Action.js.map